const coderReviewStatusHelper = {
  methods: {
    coderResponsesDisabled() {
      return this.worksheet?.reviewStatus === 'Completed'
    },
    coderResponsesReadOnly() {
      return this.readOnly() || this.coderResponsesDisabled()
    }
  }
}

export default coderReviewStatusHelper
